var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const Svg2 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 101",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "2")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_4",
    "data-name": "Capa 4"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    x: 3.76,
    y: 96.72,
    width: 88.63,
    height: 4.28
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "5.46 94.7 11.47 75.95 22.58 85.04 5.46 94.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.33,74S24,55.06,31.86,45.15l16.22,13s-19,22.54-23.89,25.86Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "66.85 0 96.24 0 49.27 56.33 32.97 43.62 66.85 0"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Svg2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/2.269496c8.svg";
export { ForwardRef as ReactComponent };